import { render, staticRenderFns } from "./SuppEditAbout.vue?vue&type=template&id=2b408e56&scoped=true&"
import script from "./SuppEditAbout.vue?vue&type=script&lang=js&"
export * from "./SuppEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b408e56",
  null
  
)

export default component.exports